import { FilePlus2, Globe, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui-kit/button';
import { useDocxBuilder } from './context';

export function DocxBuilderPanelPublish() {
  const { available, isTogglingPublish, togglePublish, templateSlug } = useDocxBuilder();

  return (
    <div className="rounded-lg border border-border bg-card p-4 space-y-4">
      <h2 className="text-sm font-semibold text-[hsl(var(--fg))]">Visibility</h2>

      {available ? (
        <>
          <p className="text-sm text-[hsl(var(--fg))]">
            This template is visible to your organization.
          </p>
          <div className="space-y-2">
            {/* Published is the point at which the template can actually be used, so the
                fill-in flow becomes the primary action and unpublishing steps back. */}
            <Button className="w-full gap-2" asChild>
              <Link to={`/templates/${templateSlug}/generate-docx`}>
                <FilePlus2 className="h-4 w-4" />
                Generate document
              </Link>
            </Button>
            <Button
              variant="outline"
              className="w-full"
              onClick={togglePublish}
              disabled={isTogglingPublish}
            >
              {isTogglingPublish && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
              Move to draft
            </Button>
          </div>
        </>
      ) : (
        <>
          <p className="text-sm text-globe-grey">
            Publish this template so your colleagues can find and use it.
          </p>
          <Button
            className="w-full gap-2"
            onClick={togglePublish}
            disabled={isTogglingPublish}
          >
            {isTogglingPublish ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Globe className="h-4 w-4" />
            )}
            Publish to organization
          </Button>
        </>
      )}
    </div>
  );
}
